import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import EmptyStateView from 'app/components/EmptyStateView'
import { Icon, Button } from '@material-ui/core'
import GroupTable from './GroupTable'
import useStyles from '../styles'

import DialogDeleteGroupPage from './dialogs/DialogDeleteGroupPage'
import DialogCreateGroupPage from './dialogs/DialogCreateGroupPage'

import * as R from 'ramda'
import { isHomelessGroup } from 'commons/groupLogic'
const DELETE_DIALOG = 'delete'
const CREATE_GROUP_DIALOG = 'create_group_delete'

export default (props) => {
  const classes = useStyles(),
    {
      apiFetchersCallback,
      pageState,
      initParentState,
      setPageState,
      parentState,
      setParentState,
      deleteGroupsRequest,
      createGroupRequest,
      pageData,
      onViewGroup,
      reRenderPage,
      history,
    } = props

  if (!parentState.toggle) {
    setParentState({
      ...parentState,
      toggle: toggleDialogs,
    })
  }

  useEffect(() => {
    return () => {
      setParentState(initParentState)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function toggleDialogs(dialogType, isOpen, data = null) {
    let newState = {}
    if (dialogType === DELETE_DIALOG) {
      if (isOpen) {
        newState = {
          ...pageState,
          isOpenDeleteDialog: isOpen,
          deletedGroupData: data,
        }
      } else {
        newState = {
          ...pageState,
          isOpenDeleteDialog: isOpen,
        }
      }
    } else if (dialogType === CREATE_GROUP_DIALOG) {
      newState = {
        ...pageState,
        subgroups: [],
      }
      setParentState({
        ...parentState,
        isOpenCreateGroup: isOpen,
      })
    }
    setPageState(newState)
  }

  function handleDeleteGroups() {
    if (!R.isEmpty(pageState.deletedGroupData)) {
      const filteredGroupData = R.filter(
        (val) => !isHomelessGroup(val),
        pageState.deletedGroupData,
      )
      toggleDialogs(DELETE_DIALOG, false)
      deleteGroupsRequest(R.map(R.prop('id'), filteredGroupData))
    }
  }

  function handleAddSubgroup(subgroup) {
    pageState.subgroups.push(subgroup)
    setPageState({
      ...pageState,
    })
    checkAndEnableSubmitBtn()
  }

  function handleDeleteSubgroup(subgroup, index) {
    pageState.subgroups && pageState.subgroups.splice(index, 1)
    setPageState({
      ...pageState,
    })
    checkAndEnableSubmitBtn()
  }

  function onGroupName(e) {
    pageState.newGroupNameTmp = e.target.value.trim()
    checkAndEnableSubmitBtn()
  }

  function checkAndEnableSubmitBtn() {
    let isAvailableSubgroups = pageState.subgroups.length > 0
    if (isAvailableSubgroups && pageState.newGroupNameTmp !== '') {
      setPageState({
        ...pageState,
        isDisableSubmitBtn: false,
      })
    } else {
      setPageState({
        ...pageState,
        isDisableSubmitBtn: true,
      })
    }
  }

  function hendleCreateGroup(formData) {
    if (pageState.subgroups.length > 0) {
      toggleDialogs(CREATE_GROUP_DIALOG, false)
      createGroupRequest({
        name: formData['newGroupName'],
        tags: pageState.subgroups.map((item) => {
          return { name: item }
        }),
      })
    }
  }

  return (
    <>
      <div className="h-full overflow-hidden flex flex-col flex-auto">
        {parentState.searchText !== '' &&
        pageData &&
        pageData.pageInfo.totalData === 0 ? (
          <EmptyStateView title={<FormattedMessage id="groups.emptyGroups" />}>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => toggleDialogs(CREATE_GROUP_DIALOG, true)}
            >
              <Icon className={classes.extendedIcon}>person_add</Icon>
              <FormattedMessage id="group.action.addGroup.label" />
            </Button>
          </EmptyStateView>
        ) : (
          <GroupTable
            apiFetchersCallback={apiFetchersCallback}
            classes={classes}
            toggleDialogs={toggleDialogs}
            CREATE_GROUP_DIALOG={CREATE_GROUP_DIALOG}
            DELETE_DIALOG={DELETE_DIALOG}
            pageData={pageData}
            onViewGroup={onViewGroup}
            reRenderPage={reRenderPage}
            history={history}
          />
        )}
      </div>

      <DialogCreateGroupPage
        parentState={parentState}
        state={pageState}
        classes={classes}
        toggleDialogs={toggleDialogs}
        hendleCreateGroup={hendleCreateGroup}
        handleAddSubgroup={handleAddSubgroup}
        onGroupName={onGroupName}
        handleDeleteSubgroup={handleDeleteSubgroup}
        CREATE_GROUP_DIALOG={CREATE_GROUP_DIALOG}
      />

      <DialogDeleteGroupPage
        state={pageState}
        classes={classes}
        toggleDialogs={toggleDialogs}
        handleDeleteGroups={handleDeleteGroups}
        DELETE_DIALOG={DELETE_DIALOG}
      />
    </>
  )
}
